import { useCallback, useRef, useState, useEffect } from "react";
import { useFaust } from "../../contexts/FaustContext";
import { useCompileOptions } from "../../hooks/useCompileOptions";
import { FileTree } from "../file-manager/FileTree";
import { ActionButtons } from "../controls/ActionButtons";
import { CompileOptions } from "../controls/CompileOptions";
import { PlotSettings } from "../controls/PlotSettings";
import { ScrollArea } from "../ui/scroll-area";
import { Separator } from "../ui/separator";

export function LeftPanel() {
    return (
        <ScrollArea className="h-full">
            <div className="flex flex-col gap-3 p-3">
                {/* File Manager */}
                <FileTree />

                <Separator className="bg-white/[0.08]" />

                {/* Action Buttons */}
                <ActionButtons />

                <Separator className="bg-white/[0.08]" />

                {/* Compile Options */}
                <CompileOptions />

                <Separator className="bg-white/[0.08]" />

                {/* Plot Settings */}
                <PlotSettings />
            </div>
        </ScrollArea>
    );
}
